import EmailUpdatedSuccessModal from './EmailUpdatedSuccessModal';

export default EmailUpdatedSuccessModal;
